import React, { useState } from "react";
import { useSelector } from "react-redux";
import classes from "./SmsComponent.module.css";
import FireboardUtils from "../../../../util/fireboard-util";
import classNames from "classnames";
import Toggle from '../../../../components/Toggle';
import CustomSms from "./CustomSms";

const messages = [
  "Your [order type] order at [location] is now ready[slotName]. Thank you.",
  "Your order from [location] is now on its way to [address].",
  "Your order at [location] for [pickup time] is waiting for you. Please contact the store at [phone] if you need assistance.",
  "Your contactless delivery has left [location] and should be there shortly.  Our driver will ring the doorbell at your address.",
  "Thank you for checking in! A Team Member will be out with your order shortly. Stay in your vehicle and call us if you haven't gotten your food in the next 5 minutes.",
  "Thank you for checking in! Your order is not quite ready yet, but a Team Member should be out to you shortly with an update.",
  "Can you please contact [location] about your order at [phone] ? Thank you.",
  "We have a question about your order at [location]. Please contact the store at [phone] as soon as you can.",
  "Your order at [location] is taking longer than expected. We apologize for the delay, please contact the store if you want to change your order.",
  "One of the items on your order from [location] is currently unavailable. Please contact the store at [phone] to select a different item. Thank you.",
  "We are having trouble locating [address]. Please contact the store as soon as possible at [phone] so we can deliver your order.",
];

const SmsRow = ({ sms, storeInfo, onHandleSend, selectedItem, iso2, smsIndex }) => {
  const [selectedAction, setSelectedAction] = useState(-1);

  const getSourceTypeFromOrderType = (type) => {
    switch (type) {
      case 5:
        return "curbside";
      case 6:
        return "online";
      case 8:
        return "call in";
      case 7:
        return "walkup";
      default:
        break;
    }
  };

  const dataObj = {
    address: selectedItem.checkInNote,
    phone: FireboardUtils.formattedPhoneNumber(storeInfo.phoneNumber, iso2),
    "pickup time": FireboardUtils.getTimeInHrsMins(selectedItem.pickupDate),
    location: storeInfo.name,
    "order type": getSourceTypeFromOrderType(selectedItem.sourceType),
    "slotName": selectedItem?.slotName,
  };

  let formatMessage = sms;
  Object.keys(dataObj).forEach((key) => {
    if (key === "address") {
      if (
        formatMessage.includes(
          "Your order from [location] is now on its way to"
        )
      ) {
        const address = dataObj[key] || "";
        const replaceableText = !!address ? `[${key}]` : `to [${key}]`;
        formatMessage = formatMessage.replace(replaceableText, address);
      } else {
        formatMessage = formatMessage.replace(
          `[${key}]`,
          dataObj[key] || "your address"
        );
      }
    } else if (key === 'slotName' && dataObj[key]) {
      formatMessage = formatMessage.replace(`[${key}]`, ` in cubby slot ${dataObj[key]}`);
    } else {
      formatMessage = formatMessage.replace(`[${key}]`, dataObj[key] || "");
    }
  });

  return (
    <div className={classNames({ [classes.smsView]: true, [classes.highligthtedAction]: selectedAction === smsIndex })}
      onMouseEnter={() => setSelectedAction(smsIndex)}
      onMouseLeave={() => setSelectedAction(-1)}
    >
      <span className={classes.smsViewText} onClick={() => onHandleSend(formatMessage, {})}>{formatMessage}</span>
    </div>
  );
};

const SmsComponent = props => {
  const { selectedItem, onHandleSend, onClose, isCustomSmsType, customSmsList, onChangeSmsType } = props;
  const storeInfo = useSelector(state => state.storeInfo);
  const currencyInfo = useSelector(state => state.currencyInfo);
  const { iso2, currency } = currencyInfo || {};

  const renderHeader = () => {
    return (
      <div className={classes.headerWrapper}>
        <div className={classes.toggleWrapper}>
          <span className={classes.optionTxt}>Standard</span>
          <Toggle selected={!isCustomSmsType} onClick={() => onChangeSmsType && onChangeSmsType()} />
          <span className={classes.optionTxt}>Custom</span>
        </div>
        <h3 className={classes.close} onClick={onClose}>X</h3>
      </div>
    );
  };

  const smsList = isCustomSmsType ? Array.isArray(customSmsList) ? customSmsList : [] : messages;
  const SmsRowComponent = isCustomSmsType ? CustomSms : SmsRow;

  return (
    <>
      {renderHeader()}
      <div className={classes.container}>
        {Array.isArray(smsList) &&
          smsList.map((message, messageIndex) => {
            return (
              <SmsRowComponent
                key={messageIndex}
                sms={message}
                storeInfo={storeInfo?.data || {}}
                onHandleSend={onHandleSend}
                selectedItem={selectedItem}
                iso2={iso2}
                currency={currency}
                smsIndex={messageIndex}
              />
            );
          })}
      </div>
    </>
  );
};

export default SmsComponent;
